import { render } from "./MBaseButton.vue?vue&type=template&id=21c69693"
import script from "./MBaseButton.vue?vue&type=script&lang=ts"
export * from "./MBaseButton.vue?vue&type=script&lang=ts"
script.render = render

export default script